import { Component, Input, OnInit } from "@angular/core";
import { ChartData } from "chart.js";
import _ from "lodash";

@Component({
	selector: "app-bar-chart",
	templateUrl: "./bar-chart.component.html",
	styleUrls: ["./bar-chart.component.scss"],
})
export class BarChartComponent implements OnInit {
	dynamicId: string = "chart-container";
	@Input() categoriesName: any;
	@Input() dataSets: any;
	@Input() barChartTitle: any;
	@Input() fullscreen: boolean;
	@Input() idBar: any;

	// ServiceOrdersByTop10Principals

	public chartData: Partial<any>;
	listColors: any = [];

	tooltips = {};

	dataLabels = {
		enabled: true,
		legend: {
			show: false, // Disable the legend
		},
		formatter(val, opts) {
			var total = opts.w.globals.stackedSeriesTotals[opts.dataPointIndex]; // Get the total for each stack
			return round((val / total) * 100) + "%";
		},
		offsetY: 0,
		style: {
			colors: ["#495057"],
		},
		dropShadow: {
			enabled: false,
		},
	};

	legend: {
		show: false; // Disable the legend
	};

	constructor() {}

	ngOnChanges() {
		let listDataSeries: any = [];
		let listCategories: any = [];

		_.map(this.dataSets, (value, index) => {
			listDataSeries.push({
				name: value.label,
				data: value.data != null ? value.data : 0,
			});
			this.listColors.push(value.backgroundColor);
		});

		listCategories = this.categoriesName;

		if (this.fullscreen) {
			this.tooltips = {
				enabled: true,
				style: {
					padding: "2px",
				},
				onDatasetHover: {
					highlightDataSeries: true,
				},
				overflowingBehavior: {
					horizontal: "flip",
					vertical: "shift",
				},
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					let listData: any = [];
					let listValue: any = [];

					listDataSeries.forEach(function (value, index) {
						listValue.push(
							listDataSeries[index].data != null
								? listDataSeries[index].data
								: 0
						);
					});

					let mergelistValue = mergeListsByIndex(listValue);

					listDataSeries.forEach(function (value, index) {
						let point = listDataSeries[index].data[dataPointIndex];

						listData.push(
							listDataSeries[index].name +
								": " +
								(point != null ? point : 0) +
								"(" +
								round(
									calculatePercentage(
										point,
										sumList(mergelistValue[dataPointIndex])
									)
								) +
								")%"
						);
					});
					return (
						'<div style="padding: 50px;">' +
						'<div style="position: relative; top: 50%;">' +
						"<b>" +
						listCategories[dataPointIndex] +
						"</b>" +
						"<br/>" +
						listToHTML(listData) +
						"<br/>" +
						"Total %: 100%" +
						"</div>"
					);
				},
			};
			this.chartData = {
				series: listDataSeries,
				chart: {
					stacked: true,
					type: "bar",
					zoom: {
						enabled: false, // Disable zooming
					},
					pan: {
						enabled: false, // Disable panning
					},
					fontFamily: "Nunito Sans, sans-serif"
				},
				colors: this.listColors,
				xaxis: {
					categories: this.categoriesName,
					labels: {
						rotate: -70,
						style: {
							fontSize: "10px",
						},
						overflow: "ellipsis",
					},
				},
			};
		} else {

			const title = this.barChartTitle;

			this.dataSets.name = this.dataSets.label;
			this.chartData = {
				series: listDataSeries,
				chart: {
					stacked: true,
					type: "bar",
					height: "400",
					sparkline: {
						enabled: false,
					},
					fontFamily: "Nunito Sans, sans-serif"
				},
				colors: this.listColors,
				plotOptions: {
					bar: {
						horizontal: true,
						legend: {
							show: false, // Disable the legend
						},
					},
				},
				legend: {
					show: false, // Disable the legend
				},
				yaxis: {
					max: 100,
				},
				xaxis: {
					categories: this.categoriesName,
					labels: {
						rotate: -70,
						maxHeight: 250,
						style: {
							fontSize: "10px",
						},
						overflow: "ellipsis",
					},
				},
				responsive: [
					{
						breakpoint: 480,
						options: {
							legend: {
								position: "bottom",
							},
						},
					},
				],
			};

			this.tooltips = {
				enabled: true,
				style: {
					padding: "2px",
				},
				onDatasetHover: {
					highlightDataSeries: true,
				},
				overflowingBehavior: {
					horizontal: "flip",
					vertical: "shift",
				},
				custom: function ({ series, seriesIndex, dataPointIndex, w }) {
					let listData: any = [];
					let listValue: any = [];

					listDataSeries.forEach(function (value, index) {
						listValue.push(
							listDataSeries[index].data != null
								? listDataSeries[index].data
								: 0
						);
					});

					let mergelistValue = mergeListsByIndex(listValue);

					listDataSeries.forEach(function (value, index) {
						let point = listDataSeries[index].data[dataPointIndex];

						listData.push(
							listDataSeries[index].name +
								": " +
								(point != null ? point : 0) +
								"(" +
								round(
									calculatePercentage(
										point,
										sumList(mergelistValue[dataPointIndex])
									)
								) +
								")%"
						);
					});
					return (
						'<div style="padding: 5px; border: 10px">' +
						"<b>" +
						listCategories[dataPointIndex] +
						"</b>" +
						"<br/>" +
						listToHTML(listData) +
						"<br/>" +
						"Total %: 100%" +
						"</div>"
					);
				},
			};
		}
	}

	ngOnInit(): void {
		this.dynamicId = this.idBar;
	}

	onDataPointMouseEnter(event: any) {
		const dataPointIndex = event.dataPointIndex;
		const seriesIndex = event.seriesIndex;
		const value = event.value;

		// Perform actions when the mouse hovers over a data point
		// console.log(`Hovered over Data Point ${dataPointIndex} in Series ${seriesIndex}. Value: ${value}`);
	}
}

function round(value: number) {
	return (Math.round(100 * value) / 100).toFixed();
}

function listToHTML(items: string[]): string {
	const htmlString = items.join("<br>");
	return htmlString;
}

function mergeListsByIndex(lists: any[][]): any[][] {
	const length = lists[0].length;

	if (!lists.every((arr) => arr.length === length)) {
		throw new Error("Lists have different lengths");
	}

	const mergedLists = Array.from({ length }, (_, i) =>
		lists.map((arr) => {
			return arr[i] != null ? arr[i] : 0;
		})
	);

	return mergedLists;
}

function sumList(arr: number[]): number {
	return arr.reduce((sum, currentValue) => sum + currentValue, 0);
}

function calculatePercentage(value: number, total: number): number {
	if (total === 0) {
		return 0; // Avoid division by zero
	}
	return (value / total) * 100;
}
